import React from "react";
import { Form } from "@jsq/ds/forms";
import { EntityFormContent } from "./EntityFormContent";
import { createEntityProfileSchema } from "./schemas";
import { defaultInitialValues, EntityFormProps, EntityProfile } from "./types";

export const EntityForm: React.FC<EntityFormProps> = ({
  initialValues,
  isUpdating,
  onBack,
  onSubmit,
  profileId,
  amlEntityTypeId,
  onDefaultQuestionsChange,
}: EntityFormProps) => {
  const mergedInitialValues = {
    ...defaultInitialValues,
    ...initialValues,
  };

  const handleSubmit = async (values: Partial<EntityProfile>) => {
    await onSubmit(values as EntityProfile);
  };

  return (
    <Form
      initialValues={mergedInitialValues}
      onSubmit={handleSubmit}
      yupValidationSchema={createEntityProfileSchema}
      submitOnlyChangedValues={false}
    >
      <EntityFormContent
        onBack={onBack}
        isUpdating={isUpdating}
        profileId={profileId}
        amlEntityTypeId={amlEntityTypeId}
        onDefaultQuestionsChange={onDefaultQuestionsChange}
      />
    </Form>
  );
};
